import { SharedPagedRequest } from "@sharedcommon/model/shared-page-request.model";
import { CalculationStatus } from "@sharedcommon/model/calculation-status.model";

export class SampleFilterDto extends SharedPagedRequest {
  ids: string[];
  label: string;
  productCode: string;
  code: string;
  technicianName: string;
  startCalculation: Date|string;
  endCalculation: Date|string;
  startValidation: Date|string;
  endValidation: Date|string;
  calculationBy: string;
  farmLabel: string;
  speciesLabel: string;
  calculationStatus: CalculationStatus;
  entityLabel: string;
  referenceLabel: string;
  referencePredictionModelLabel: string;
  archived: boolean;
  distributor: string;
  /** To test if the sample is included in prediction model codes (from another micro-service) */
  inPredictionModelCodes: string[];
  /** To test if the sample is included in reference codes (from another micro-service) */
  inReferenceCodes: string[];
  /** To test if the sample is included in level codes (from another mirco-service) */
  inLevelCodes: string[];
  /** To test if the business unit code of the sample is included in this parameter */
  inBusinessUnitCodes: string[];
  /** To test if the customer code of the sample is included in this parameter */
  inSupplierCodes: string[];
  /** To test if the entity codes of the sample is included in this parameter */
  inEntityCodes: string[];
  /** To test if the distributor of sample is included in this parameter */
  inDistributors: string[];
  /** To test if the farm name of the sample is included in this parameter */
  inFarmLabels: string[];
  /** To test if the species of sample is included in this parameter */
  inSpeciesIds: string[];
  /** To test if the technician name sample is included in this parameter */
  inTechnicianNames: string[];
  /** To test if the validation date of sample is after this parameter */
  inStartValidation: Date|string;
  /** To test if the validation date of sample is before this parameter */
  inEndValidation: Date|string;
  /** To test if the reception date of sample is after this parameter */
  inStartReception: Date|string;
  /** To test if the reception date of sample is before this parameter */
  inEndReception: Date|string;
}